import DossierActions from "./DossierActions.jsx";
import DossierDocumentsStats from "./DossierDocumentsStats.jsx";
import DossierDocumentsTable from "./DossierDocumentsTable.jsx";
import DossierPendingDocumentsTable from "./DossierPendingDocumentsTable.jsx";
import DossierPendingToSignDocumentsTable from "./DossierPendingToSignDocumentsTable.jsx";
import ProviderInformationCard from "./ProviderInformationCard.jsx";
import DocumentsActions from "./DocumentsActions.jsx";
import Example from "./Example.jsx";
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class Dossier extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.currentHistoryId = 0;
        this.state = {
            sharedUsers:[],
            files:[],
            doc2SignDocuments: [],
            addDocuments:[],
            onceDocuments:[],
            documentType:'new',
            search: '',
            approved:[],
            expired:[],
            historyFiles:[],
            frequencies: [
                { key : "once", value : "Único" },
                { key : "weekly", value : "Semanal" },
                { key : "monthly", value : "Mensual" },
                { key : "quarterly", value : "Trimestral" },
                { key : "yearly", value : "Recurrente" },
            ],
            aditionalDocuments:[],
            documents: [],
            detail: null,
            totalOnce: 0,
            totalRecurrent: 0,
            totalExpired:0,
            historyPage:1,
            total: 0, 
            historyTotal: 0, 
        };
        this.getFileImage = this.getFileImage.bind(this)
        this.updateCurrentHistoryPage = this.updateCurrentHistoryPage.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.getNameFile = this.getNameFile.bind(this);
        this.getHistoryFile = this.getHistoryFile.bind(this);
        this.resendInvitation = this.resendInvitation.bind(this)
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getDocuments()
        this.addDoc2SignDocument()
    }

    deleteDossier = ()=>{
        const { lang } = this.context;
        let data = {
            'id':this.props.invitation_id,
            'is_internal':0
        }
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_este_expediente'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {

            if (result.isConfirmed) {
                axios.post('/api/dossiers/delete_dossier',data).then(res=>{
                    swal.fire({
                        text: lang.get('messages.expediente_eliminado'),
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText: lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        window.location.href = '/client';
                    });
                })
            }
        });

    }
    openReplaceModal = ()=>{
        if (this.childRef) {
            this.childRef.handleOpenModal();
          }
        $('#replaceDossiers').modal('show')
    }
    getData = ()=>{
        let data = {
            'id':this.props.invitation_id,
            'is_internal':0
        }
        axios.post('/api/shared_dossiers/data',data).then(res=>{
            this.setState({approved: res.data.approved})
            this.setState({expired: res.data.expired})
            this.setState({sharedUsers: res.data.sharedUsers})
            if(res.data.approvedTotal == 0 && res.data.expiredTotal == 0){
                Swal.fire({
                    text: 'Es nescesario que los expedientes cuenten con documentos aprobados ó en el historial para que puedas realizar esta acción',
                    icon: "info",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
            }else{
                $('#shareModal').modal('show')
            }
        });


    }

    getFileImage(file){
        let extension_file = file.file.path.split('.').pop()
        var type    = 'iframe';
        var images  = ['jpg', 'jpeg', 'png', 'gif'];
        if(images.includes(extension_file.toLowerCase())){
            type = 'image';
        }
        $.magnificPopup.open({
            items: {
                src: '/files/'+ file.id
            },
            type: type
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAditionalDocuments();
        });
    }

    updateCurrentPageOnce(page){
        this.setState({pageOnce: page}, function () {
            this.getAditionalDocuments();
        });
    }

    updateCurrentHistoryPage(page){
        this.setState({historyPage: page}, function () {
            this.getHistoryFile();
        });
    }

    async addDoc2SignDocument() {
        const urlParams = new URLSearchParams(window.location.search);
        const documentId = urlParams.get('documentId')?.split('?')[0];
        const doc2signId = urlParams.get('id');

        if (! documentId && ! doc2signId) {
            return;
        }

        window.blockUI();

        try {
            const personProviderId = this.props.id;

            const response = await axios.post(`/api/invitations/${personProviderId}/documents/${documentId}/doc2sign`, {
                'doc2sing_document_id': doc2signId,
            });

            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
            }

            const responseData = response.data.data;
           
            const createdAt = responseData.file.created_at;
            const formattedCreatedAt = createdAt.split(' ')[0];
            this.setState(prevState => ({
                detail: {
                    ...prevState.detail,
                    frequencyOnly: {
                        ...prevState.detail.frequencyOnly,
                        pendingToSign: [...prevState.detail.frequencyOnly.pendingToSign, {
                            id: responseData.document.id,
                            title: responseData.document.title,
                            file_id: responseData.file.id,
                            requestedDate: formattedCreatedAt,
                            personDocument: {
                                requestedDate: formattedCreatedAt
                            },
                            document: {
                                title: responseData.document.title,
                                type_id: DOC2SIGN_DOCUMENT_TYPE,
                                version: responseData.document.version,
                            }
                        }]
                    }
                }
            }));

            this.setState(prevState => ({
                detail: {
                    ...prevState.detail,
                    totalOnlyDocuments: prevState.detail.totalOnlyDocuments + 1
                }
            }));
            location.reload()
        } catch {

        } finally {
            window.unblockUI();
        }
    }

    /**
     * Handle additional document selection.
     *
     * @todo Support "New documents" and "Existing Documents" sections.
     * @todo Fix "aditional" typo to "additional".
     *
     * @param   {object} document
     */
    additionalDocumentSelected(e, document) {
        this.setState({
            aditionalDocuments: [document],
        });
    }

    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getAditionalDocuments();
        });
    }

    async getDocuments(){
      
        const res = await axios.get('/api/dossiers/documents/' + this.props.id)
        this.setState({detail: res.data})

        const totalOnce = this.state.detail.frequencyOnly.pending.length +
            this.state.detail.frequencyOnly.loaded.length +
            this.state.detail.frequencyOnly.approved.length +
            this.state.detail.frequencyOnly.rejected.length +
            this.state.detail.frequencyOnly.pendingToSign.length;


        const totalRecurrent = this.state.detail.frequencyRecurrent.pending.length +
            this.state.detail.frequencyRecurrent.loaded.length +
            this.state.detail.frequencyRecurrent.approved.length +
            this.state.detail.frequencyRecurrent.rejected.length +
            this.state.detail.frequencyRecurrent.pendingToSign.length;

        const totalExpired = this.state.detail.expired.documents.length 
        const showDeleteDocumentsModal = 
            ( this.state.detail.frequencyRecurrent?.loaded?.length || 0) > 0 ||
            ( this.state.detail.frequencyRecurrent?.approved?.length || 0) > 0 ||
            ( this.state.detail.frequencyRecurrent?.rejected?.length || 0) > 0 ||
            ( this.state.detail.frequencyRecurrent?.expired?.length || 0) > 0 ||
            ( this.state.detail.frequencyOnly?.loaded?.length || 0) > 0 ||
            ( this.state.detail.frequencyOnly?.approved?.length || 0) > 0 ||
            ( this.state.detail.frequencyOnly?.rejected?.length || 0) > 0; 
        this.setState({
            showDeleteDocumentsModal:showDeleteDocumentsModal,
            totalOnce: totalOnce,
            totalRecurrent: totalRecurrent,
            totalExpired: totalExpired,
            actionsEnabled:  this.state.detail.actionsEnabled
        })
    }

    getNameFile(path) {
        const parts = path.split('/');
        return parts[parts.length - 1];
    }
    async getHistoryFile(id,page){
        if(id == undefined){
            id = this.currentHistoryId;
        }
        if(page == undefined){
            page = this.state.historyPage
        }
        this.currentHistoryId = id;
        this.setState({historyPage: page})
        window.blockUI();
        const query = new URLSearchParams();
        query.append('page', this.state.historyPage)
        query.append('person_provider_id', this.props.id)
        query.append('maxRecords', this.state.maxRecords)
        const qs = query.toString();
        const res =  await axios.get('/api/documents/history_file/' + this.props.id + '/' + id +`?${qs}`);
        const data = res.data.data;
        this.setState({historyFiles: data, historyTotal: res.data.total});
        window.unblockUI();
    }

    async resendInvitation() {
        window.blockUI();
        const { lang } = this.context;
        await axios.put(
            '/api/invitations/' + this.props.invitation_id + '/forwarding',
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: lang.get('messages.invitacion_reenviada'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        }).catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        }).then(() => {
            window.unblockUI();
        });;
    }

    confirmDelete = ()=>{
        const { lang } = this.context;
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_esta_invitacion'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText:  lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteInvitation();
            }
        });
    }

    deleteInvitation = () => {
        window.blockUI();
        axios.delete(
            '/api/persons/invitation/' + this.props.invitation_id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            window.location.href = '/';
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: 'Algo salió mal, intenta de nuevo',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }
    deletePersonDocuments = ()=>{
        axios.post('/api/document_dossier/documents/delete',{
            ids:[10198,10199]
        }).then(res=>{
            console.log(res)
        })
    }
    render() {
        const { lang } = this.context;
        return (<div> 
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap w-100">
                    <ProviderInformationCard person_provider_id={this.props.id}/>
                    <div className="text-center align-items-center d-flex col-3">
                    <div className="text-center align-items-center    ">
                        <span className="text-dark font-weight-bold">{lang.get('messages.estatus')}</span><br/>
                        <span className={'badge badge-'+this.state.detail?.status.name.toString().toLowerCase()}>{lang.get('messages.'+this.state.detail?.status.name.toString().toLowerCase() )}</span>
                    </div>
                    { ( this.state.detail?.transfer== true && this.props.dossier_type==2 )  &&

                    <div><a className="text-dark-50 font-size-sm a-underline mr-10" href={'/invitation/'+this.state.detail?.invitation_id}>{lang.get('messages.en_transferencia')}</a></div>
                    }
                    </div>
                    {this.props.usermode == 'client' &&
                        <DossierActions
                            showDeleteDocumentsModal = {this.state.showDeleteDocumentsModal}
                            transfer={this.state.detail?.transfer}
                            actions_enabled={this.state.detail?.actionsEnabled}
                            permissions={this.props.permissions}
                            dossier_name={this.props.dossier_name}
                            dossier_id={this.state.detail?.dossier.id}
                            person_provider_id={this.props.id}
                            ids={this.state.detail?.ids}
                            invitation_id={this.props.invitation_id}
                            type={this.state.detail?.type}
                            has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                        />
                    }
                </div>
            </div>
            {  (this.state.detail?.actionsEnabled == false) &&
            <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                <div><span className="flaticon2-warning mr-2 icon-3x"></span></div>
                <div>
                    <h3>{lang.get('messages.nota')}</h3>
                    {lang.get('messages.este_expediente_cuenta_con_documentos_que_no_puedes_ver_con_tu_perfil_de_usuario_es_por_eso_que_el_estatus_puede_no_coincidir_con_los_documentos_que_visualizas')}
                </div>
            </div>
            }
            <DossierDocumentsStats detail={this.state.detail} />
            <div>
                <div className="card card-custom gutter-b">
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-line">
                            <li className="nav-item">
                                <a className="nav-link  active" data-toggle="tab" href="#kt_tab_pane_1">{lang.get('messages.unicos')} &nbsp;<span className="badge badge-secondary"> { this.state.totalOnce}</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-toggle="tab" href="#kt_tab_pane_2">{lang.get('messages.recurrentes')} &nbsp;<span className="badge badge-secondary">{ this.state.totalRecurrent }</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-toggle="tab" href="#kt_tab_pane_3">{lang.get('messages.historial')} &nbsp;<span className="badge badge-secondary">{this.state.detail?.expired.documents.total_documents}</span></a>
                            </li>
                        </ul>
                        <div className="tab-content mt-5" id="myTabContent">
                            <div className="tab-pane fade show active" id="kt_tab_pane_1" role="tabpanel" aria-labelledby="kt_tab_pane_1">
                                <table className="table table-borderless m-0 table-valign">
                                    <tbody> 
                                        <DossierPendingDocumentsTable
                                            can_upload_files={this.props.can_upload_files}
                                            title={lang.get('messages.por_cargar')}
                                            personProviderId={this.props.id}
                                            type="only"
                                            user_mode={this.props.usermode}
                                            permissions={this.props.permissions}
                                            showRejectedMessage={false}
                                            documents={this.state.detail?.frequencyOnly.pending}
                                        />
                                        {this.props.has_doc_2_sign_enabled == 'true' &&
                                        <DossierPendingToSignDocumentsTable
                                            title={lang.get('messages.pendiente_de_firmar')}
                                            documents={this.state.detail?.frequencyOnly.pendingToSign}
                                        />
                                        }
                                        <DossierDocumentsTable
                                            title={lang.get('messages.por_revisar')}
                                            param={this.props.usermode == 'provider' ? 'show_file' : 'review_file'}
                                            showRejectedMessage={false}
                                            user_mode={this.props.usermode}
                                            personProviderId={this.props.id}
                                            permissions={this.props.permissions}
                                            type="only"
                                            documents={this.state.detail?.frequencyOnly.loaded}
                                            has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                        /> 
                                        <DossierDocumentsTable
                                            title={this.props.has_doc_2_sign_enabled === 'true' 
                                            ? lang.get('messages.aprobados__firmados') 
                                            :  lang.get('messages.aprobados') }
                                            param="show_file"
                                            showRejectedMessage={false}
                                            user_mode={this.props.usermode}
                                            personProviderId={this.props.id}
                                            permissions={this.props.permissions}
                                            type="only"
                                            documents={this.state.detail?.frequencyOnly.approved}
                                            has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                        />
                                        </tbody>
                                        </table>
                                        <table className="table table-borderless m-0 table-valign">
                                    <tbody> 
                                        <DossierDocumentsTable
                                            title={lang.get('messages.rechazados')}
                                            param="show_file"
                                            showRejectedMessage={true}
                                            user_mode={this.props.usermode}
                                            personProviderId={this.props.id}
                                            permissions={this.props.permissions}
                                            type="only"
                                            documents={this.state.detail?.frequencyOnly.rejected}
                                            has_doc_2_sign_enabled={this.props.has_doc_2_sign_enabled}
                                        />
                                    </tbody>
                                </table>
                            </div>
                            <div className="tab-pane fade" id="kt_tab_pane_2" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                <table className="table table-borderless m-0 table-valign">
                                    <tbody>
                                        <DossierPendingDocumentsTable
                                            title={lang.get('messages.por_cargar')}
                                            type="recurrent"
                                            user_mode={this.props.usermode}
                                            permissions={this.props.permissions}
                                            personProviderId={this.props.id}
                                            showRejectedMessage={false}
                                            documents={this.state.detail?.frequencyRecurrent.pending}
                                        />
                                        <DossierDocumentsTable
                                            title={lang.get('messages.por_revisar')}
                                            permissions={this.props.permissions}
                                            param={this.props.usermode == 'provider' ? 'show_file' : 'review_file'}
                                            showRejectedMessage={false}
                                            personProviderId={this.props.id}
                                            user_mode={this.props.usermode}
                                            type="recurrent"
                                            documents={this.state.detail?.frequencyRecurrent.loaded}
                                        />
                                        <DossierDocumentsTable
                                            title={lang.get('messages.aprobados')}
                                            permissions={this.props.permissions}
                                            param="show_file"
                                            showRejectedMessage={false}
                                            user_mode={this.props.usermode}
                                            personProviderId={this.props.id}
                                            type="recurrent"
                                            documents={this.state.detail?.frequencyRecurrent.approved}
                                        />
                                        </tbody>
                                </table>
                                <table className="table table-borderless m-0 table-valign">
                                    <tbody>
                                        <DossierDocumentsTable
                                            title={lang.get('messages.rechazados')}
                                            param="show_file"
                                            showRejectedMessage={true}
                                            permissions={this.props.permissions}
                                            user_mode={this.props.usermode}
                                            personProviderId={this.props.id}
                                            type="recurrent"
                                            documents={this.state.detail?.frequencyRecurrent.rejected}
                                        /></tbody></table> 
                            </div>
                            <div className="tab-pane fade" id="kt_tab_pane_3" role="tabpanel" aria-labelledby="kt_tab_pane_3">
                                <div className="accordion text-dark-75  font-size-lg" id="accordionExample">
                                { this.state.detail?.expired.documents.groups.map((d, i) => {
                                    {  
                                    return  <div className="card" key={i}>
                                                <div className="card-header-collapse" id="headingOne">
                                                    <div className="mb-0 d-flex align-items-center">
                                                        <button className="btn btn-block text-left mr-2 text-dark-75 font-weight-bolder font-size-lg"
                                                                type="button" data-toggle="collapse"
                                                                onClick={ ()=>{ this.getHistoryFile(d.header.id,1) } }
                                                                data-target={`#collapse${d.header.id}`}
                                                                aria-expanded="false" aria-controls="collapseOne">
                                                                <i className="flaticon2-plus mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                <i className="flaticon2-line mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                                { d.header.title } &nbsp;<span className="badge rounded-circle text-white" style={{"backgroundColor": "#B5B5C3"}}>{d.total_documents}</span>

                                                                <span className="text-dark-50" style={{"fontSize": "12px", "marginLeft": "130px"}}>
                                                                    <span className="tooltip-mdl">
                                                                        <span className="d-inline-block text-truncate" style={{"max-width": "200px", "position": "relative", "top": "5px"}}>{lang.get('messages.frecuencia')}: {d.header.period}</span>
                                                                        <span className="tooltip-text-mdl">{d.header.period}</span>
                                                                    </span>
                                                                    <span style={{"marginLeft": "50px"}}>{lang.get('messages.primer_documento')}: {d.firstDocumentDate}</span>
                                                                    <span style={{"marginLeft": "50px"}}>{lang.get('messages.ultima_carga')}: {d.lastDocumentDate}</span>
                                                                </span>
                                                        </button>
                                                        <div className="pr-4 font-weight-bolder">

                                                        </div>
                                                    </div>
                                                </div>
                                                <div id={`collapse${d.header.id}`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                    <div className="card-body">
                                                        <table className="table table-borderless m-0 table-valign">
                                                            <thead>
                                                                <tr>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            { this.state.historyFiles.map((d, i) => {
                                                                const documentTitle = `${d.file.title} ${new Date(d.start_date).toLocaleString('es-ES', { month: 'long', year: 'numeric' }).replace(/^\w/, c => c.toUpperCase())}`;
                                                                return <tr key={d.id}>
                                                                    <td style={{width: "20px"}}><img src={"/assets/img/" + window.getMimeSVG(d.file.extension!=undefined && d.file.extension.length>0 ? d.file.extension : d.file.path)}/></td>
                                                                    <td>
                                                                        <b>{d.file.title}
                                                                        <strong>
                                                                        &nbsp; {new Date(d.start_date).toLocaleString('es-ES', { month: 'long', year: 'numeric' })
                                                                                .replace(/^\w/, c => c.toUpperCase())}
                                                                        </strong>   
                                                                        </b>
                                                                        <div className="text-dark-65 font-size-sm" >
                                                                            ( {lang.get('messages.solicitado_el')} {  d.created  }
                                                                            &nbsp;
                                                                            {lang.get('messages.cargado_el')} {  d.loaded  } 
                                                                            &nbsp;
                                                                            {lang.get('messages.aprobado_el')} { d.approval_date  }
                                                                            &nbsp;
                                                                            {lang.get('messages.expiro_el')} {d.expiration_date })
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-right">  
                                                                        <DocumentsActions title={documentTitle}  param="show_file" user_mode={this.props.usermode} document={d} person_provider_id={this.props.id} permissions={this.props.permissions} />       
                                                                    </td>
                                                                </tr>
                                                            })}
                                                            </tbody>
                                                        </table>

                                                    {this.state.historyTotal > this.state.maxRecords  &&
                                                    <SimplePagination
                                                            updateCurrentPage={this.updateCurrentHistoryPage}
                                                            currentPage={this.state.historyPage}
                                                            totalFiles={this.state.historyTotal}
                                                            split={this.state.maxRecords} />}
                                                </div>
                                            </div>
                                        </div>
                                    }})}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default Dossier;

if (document.getElementById('Dossier')) {
    ReactDOM.render(<Dossier />, document.getElementById('Dossier'));
}
